import { Button } from 'antd';
import { getLocalTime } from '../../../../lib';
import { IAPIAppConfigItem } from '../../../../model/api-modules/app-config';
import { SortOrder } from 'antd/lib/table/interface';
import { CommonStatusStep, IAPIUserInfo } from '../../../../model/api-modules';
import getFormatMessage from '../../../../locales/get-format-message';

const getStatusText = (status: CommonStatusStep) => {
  switch (status) {
    case CommonStatusStep.Pending:
      return getFormatMessage('common_status_step_pending');
    case CommonStatusStep.Resolve:
      return getFormatMessage('common_status_step_approved');
    case CommonStatusStep.Reject:
      return getFormatMessage('common_status_step_rejected');
    default:
      return '-';
  }
};

export const getColumns = (
  onEdit: (record: IAPIAppConfigItem) => void,
  onDel: (record: IAPIAppConfigItem) => void,
  userInfo: IAPIUserInfo | null
) => {
  return [
    {
      title: getFormatMessage('id'),
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: getFormatMessage('app'),
      dataIndex: 'App',
      key: 'App',
      defaultSortOrder: 'descend' as SortOrder,
    },
    {
      title: getFormatMessage('domain_host_name'),
      dataIndex: 'Domain',
      key: 'Domain',
    },
    {
      title: getFormatMessage('env'),
      dataIndex: 'Env',
      key: 'Env',
    },
    {
      title: getFormatMessage('region'),
      dataIndex: 'Region',
      key: 'Region',
    },
    {
      title: getFormatMessage('status'),
      key: 'Status',
      render: (record: IAPIAppConfigItem) => (
        <div>
          <div>{getStatusText(record.Status)}</div>
        </div>
      ),
    },
    {
      title: getFormatMessage('last_modify_time_local'),
      key: 'LastModify',
      render: (record: IAPIAppConfigItem) => (
        <div>
          <div>
            {getLocalTime(
              record.ModifyTime as unknown as Date,
              userInfo?.UserSettings?.Timezone
            )}
          </div>
          <div>{isNaN(record.LastUpdateBy) && record.LastUpdateBy}</div>
        </div>
      ),
    },
    {
      title: getFormatMessage('operate'),
      key: 'action',
      render: (text: string, record: IAPIAppConfigItem) => (
        <div>
          <Button
            className="gc-btn gc-btn-primary btn-admin is-small"
            style={{ marginRight: '10px' }}
          >
            <span onClick={() => onEdit(record)}>
              {getFormatMessage('edit')}
            </span>
          </Button>
          <Button
            type="primary"
            className="btn-admin"
            danger
            size="small"
            onClick={() => onDel(record)}
          >
            {getFormatMessage('delete')}
          </Button>
        </div>
      ),
    },
  ];
};
